<template>
  <dashboard-widget title="DUTY-PAID PRODUCT SHIPMENTS" :zoomed="zoomed" :width="width" :enableDelete="enableDelete"
                      @zoom="$emit('zoom','DashboardProductsDutyPaidShipments')"
                      @delete="$emit('delete','DashboardProductsDutyPaidShipments')"
                      @close="$emit('close')">
    <v-btn-toggle v-model="period" mandatory @change="refresh" style="position:absolute;top:40px;left:10px" :style="zoomed?'top:50px':''">
      <v-btn x-small value="Last30Days">Every 30 days</v-btn>
      <v-btn x-small value="Monthly">By month</v-btn>
    </v-btn-toggle>
    <v-btn-toggle v-if="valuePermission" v-model="view" mandatory @change="draw" style="position:absolute;top:40px;right:10px" :style="zoomed?'top:50px':''">
      <v-btn x-small>Bottles</v-btn>
      <v-btn x-small>$</v-btn>
    </v-btn-toggle>
    <div ref="chart" style="position:relative;top:25px"/>
  </dashboard-widget>
</template>

<script>
import {format,add} from 'date-fns'

export default {
  name: 'DashboardProductsDutyPaidShipments',
  props: {
    from: {type:String, required:true},
    to: {type:String, required:true},
    zoomed: {type:Boolean, required:false, default:false},
    width: {type:Number, required:false, default:290},
    enableDelete: {type: Boolean, required:false, default:false}
  },
  data() {
    return {
      view: 0,
      period: 'Last30Days',
      chart: null,
      summary: [],
      options: {chartArea:{height:this.zoomed?'80%':'95%',width:'90%',left:this.zoomed?50:40},
                fontSize:this.zoomed?12:10,
                height:this.zoomed?385:225,
                colors: ['green'],
                vAxis:{format: '#,###',gridlines:{count:3},minorGridLines:{count:0},viewWindowMode:"maximized"},
                hAxis:{textStyle:{color:this.zoomed?'black':'white'},showTextEvery:4},
                legend:{ position: "none"}}
    }
  },
  computed: {
    drawer() {
      return this.$store.state.drawer;
    },
    valuePermission() {
      return this.$store.getters.company.permissions.includes('values');
    }
  },
  watch: {
    dark() {
      this.draw();
    },
    drawer() {
      this.draw();
    },
    from() {
      this.refresh();
    },
    to() {
      this.refresh();
    }
  },
  async mounted() {
    if (window.google) {
      window.google.charts.load('current', {'packages':['corechart']});
      window.google.charts.setOnLoadCallback(() => {
        if (this.$refs.chart == undefined)
          return;
        this.chart = new window.google.visualization.LineChart(this.$refs.chart);
        this.refresh();
      });
    }
  },
  methods: {
    async refresh() {
      const results = await this.$apiCall(`query DashboardProductsDutyPaidShipments($from:Date!, $to:Date!, $period:SummaryPeriod!) {
                                            productShippingSummary(from:$from, to:$to, period:$period) {
                                              periodStart,inBondCases,inBondAmount,dutyPaidBottles,dutyPaidAmount
                                            }
                                          }`, {from:this.from, to:this.to, period:this.period});
      if (!results.error) {
        this.summary = results.data.productShippingSummary;
        this.draw();
      }
    },
    draw() {
      if (this.chart === null)
        return;

			const dataLineChart = [["Period","Total",{role:"tooltip",type:"string"}]];

      const base = this.period === 'Monthly' ? new Date(format(new Date(), 'yyyy-MM') + '-01T00:00:00') : new Date();
      const dateFormat = this.period === 'Monthly' ? 'yyyy-MM' : 'yyyy-MM-dd';
      let range = 24;
			while (range--) {
        const date = format(add(base, this.period === 'Monthly' ? {months:-1*range} : {days:-30*range}), dateFormat);
        dataLineChart.push([date,0,this.date(date)+(this.view===0?'\nBottles: 0':'\nAmount: $0.00')]);
      }
      if (this.period !== 'Monthly')
        dataLineChart.splice(24, 1);

      for (const infoline of this.summary) {
        let index = 0;
        while (index < dataLineChart.length)
          if (dataLineChart[index][0] === infoline.periodStart) {
            const line = dataLineChart[index];
            line[1] = this.view === 0 ? infoline.dutyPaidBottles : infoline.dutyPaidAmount;
            line[2] = this.date(line[0]) + (this.view === 0  ? "\nBottles: " + this.number(infoline.dutyPaidBottles) : "\nAmount: " + this.currency(infoline.dutyPaidAmount));
            break;
          }
          else
            index++
      }
      const data = window.google.visualization.arrayToDataTable(dataLineChart);
      this.options.vAxis.format = (this.view === 0 ? '' : '$') + '#,###';
      this.options.vAxis.textStyle = {color:this.darkMode?'#ffffff':'#3d3d3d'};
      this.options.vAxis.baselineColor = this.darkMode?'#ffffff':'#3d3d3d';
      this.options.width = this.zoomed ? 480 : this.width-30;
      this.chart.draw(data, {...this.options, backgroundColor:this.darkMode?'#1e1e1e':'white'});
    },
    date(d) {
      if (this.period === 'Monthly')
        return format(new Date(d+'-01T00:00:00'), 'MMMM yyyy');
      return this.$formatDate(d) + ' to ' + this.$formatDate(format(add(new Date(d+'T00:00:00'),{days:29}),'yyyy-MM-dd'));
    },
    number(n) {
      return this.$number(n, 0);
    },
    currency(c) {
      return this.$currency(c);
    }
  }
}
</script>
